import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-reset",
	templateUrl: "./reset.component.html",
	styleUrls: ["./reset.component.scss"]
})
export class ResetComponent implements OnInit, OnDestroy {
	private subscriptions: Subscription[] = [];
	private email: string;
	private code: string;

	public password: string;
	public password2: string;

	public errormessage: string;
	public success = false;

	constructor(public router: Router, private route: ActivatedRoute, private api: ApiService) { }

	ngOnInit() {
		this.subscriptions.push(this.route.queryParams.subscribe(params => {
			this.email = params["email"];
			this.code = params["code"];
		}));
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) {
			sub.unsubscribe();
		}
	}

	Reset() {
		this.errormessage = undefined;
		this.success = false;
		if (this.password !== this.password2) {
			this.errormessage = "Passwords must match";
			return;
		}
		this.api.ResetPassword(this.email, this.code, this.password).then(() => {
			this.success = true;
		}).catch(err => {
			if (err && err.status && (err.status === 400 || err.status === 401)) {
				this.errormessage = "Invalid email or reset code";
			} else {
				this.errormessage = "Reset failed";
			}
		});
	}

}
